import {dataClient} from 'data-client'
import axios from 'axios';

const apiAxios = axios.create({
    baseURL: 'https://coaz.org:8085',
    withCredentials: true,
});

const client = dataClient({
    axios:apiAxios,
    authAxios:apiAxios,
    service:'cpd',
    authService:'auth',
    logoutUrl:`https://portal.coaz.org/_login?successUrl=${window.location.href}`});

/* const apiAxios = axios.create({
    baseURL: 'http://localhost:8081',
    withCredentials: true,
});

const authAxios = axios.create({
    baseURL: 'http://localhost:8080',
    withCredentials: true,
});

const client = dataClient({
    axios:apiAxios,
    authAxios:authAxios,
    logoutUrl:`http://localhost:3000/_login?successUrl=${window.location.href}`}); */

export default client;